import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { IndustryHierarchyItemBase } from './industry-hierarchy-item';

export class SystemSection extends IndustryHierarchyItemBase implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'SystemSection';
  readonly apiRoute: string = CONFIG.apiRoutes.systemSection;

  code: string;
  plantUnitId: string;
  loadFromJson(data) {
    super.loadFromJson(data);
    this.code = data.code;
    this.plantUnitId = data.plantUnitId;
  }
}
